<atx-product-card-icons
  [product]="product"
  [language]="language$ | async"
  [showGenderIcon]="isGenderIconShown()"
  [showNewIcon]="showNewIcon()"
  [showMraIcon]="showMraIcon()"
  [dateFormat]="dateFormat$ | async"
  [showEstimatedDeliveryDate]="showEstimatedDeliveryDate$ | async"
  [showPopularityIcon]="showPopularityIcon"
></atx-product-card-icons>
